import { AccountsType, LoginAccountType, MonorepoType, useLoginInfo } from '@yaotai/common-utils';
import { useYaotaiGlobalContextState } from '../contexts';

export type UserInfo = {
  account: string;
  accounts: AccountsType;
  login_type: LoginAccountType;
  name: string;
  space_first_login?: boolean;
  uid: string;
} & AccountsType;

export function useUserInfo({ monorepoType }: { monorepoType?: MonorepoType } = {}) {
  const { rbacUserInfo = {} as UserInfo } = useLoginInfo<UserInfo>();
  const { allAccountInfo } = useYaotaiGlobalContextState();

  return {
    ...rbacUserInfo,
    ...rbacUserInfo.accounts,
    ...(allAccountInfo?.accounts || {}),
    allAccounts: allAccountInfo?.accounts,
  };
}
